export default "/static/explore/86f255d8923c60e93c55378a783a789bb15b2d64/_next/static/images/reminders-hearts-bg-33794a240c3d96f529bda1a6aefa6819.jpg";